import request from '@/utils/request'


// 查询联盟提现账户列表
export function listUnionWithdrawalAccount(query) {
  return request({
    url: '/union/union/withdrawal/account/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询联盟提现账户分页
export function pageUnionWithdrawalAccount(query) {
  return request({
    url: '/union/union/withdrawal/account/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询联盟提现账户详细
export function getUnionWithdrawalAccount(data) {
  return request({
    url: '/union/union/withdrawal/account/detail',
    method: 'get',
    params: data
  })
}

// 新增联盟提现账户
export function addUnionWithdrawalAccount(data) {
  return request({
    url: '/union/union/withdrawal/account/add',
    method: 'post',
    data: data
  })
}

// 修改联盟提现账户
export function updateUnionWithdrawalAccount(data) {
  return request({
    url: '/union/union/withdrawal/account/edit',
    method: 'post',
    data: data
  })
}

// 删除联盟提现账户
export function delUnionWithdrawalAccount(data) {
  return request({
    url: '/union/union/withdrawal/account/delete',
    method: 'post',
    data: data
  })
}
